/*
 *
 * CommunicationNewMobile constants
 *
 */

export const FLUSH_STATE = 'app/CommunicationNewMobile/FLUSH_STATE';

export const UPDATE_COMMUNICATION =
  'app/CommunicationNewMobile/UPDATE_COMMUNICATION';
export const UPDATE_COMMUNICATION_SUCCESS =
  'app/CommunicationNewMobile/UPDATE_COMMUNICATION_SUCCESS';
export const UPDATE_COMMUNICATION_ERROR =
  'app/CommunicationNewMobile/UPDATE_COMMUNICATION_ERROR';
